import { RetailerApiClient } from '@/services/RetailerApiClient.js'

export class PurchaseService {
  static getPurchasePeriods(query) {
    return RetailerApiClient.get('purchase-periods', { params: query })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
